
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/servicos/pos-venda",
      function () {
        return require("private-next-pages/servicos/pos-venda.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/servicos/pos-venda"])
      });
    }
  